export default "__VITE_PUBLIC_ASSET__2d3b6201__"